/**
 * @ngdoc directive
 * @name donationform
 *
 * @description
 * Donation Form
 */
module.directive('donationform', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            formModel: '='
        },
        controller: ['$scope', '$location', '$anchorScroll', 'drupal', '$state', function ($scope, $location, $anchorScroll, drupal, $state) {

            /* update adress with autocomplete result */
            $scope.$watchCollection('formModel.adresse', function (newValue) {
                var gmodel = newValue;
                var result = {};
                var i, l;

                if (gmodel && gmodel.address_components) {

                    /* google format parser */
                    l = gmodel.address_components.length;
                    for (i = 0; i < l; i += 1) {
                        result[gmodel.address_components[i].types[0]] = gmodel.address_components[i].long_name;
                    }

                    /* set result */
                    $scope.formModel.route = result.street_number + ' ' + result.route;
                    $scope.formModel.ville = result.locality;
                    $scope.formModel.codepostal = result.postal_code;
                    $scope.formModel.pays = result.country;
                }
            });

            /* form submission handler */
            $scope.sendPaymentForm = function (isValid) {
                var dest;
                $scope.formModel.pending = true;

                if (!isValid) {
                    // form is still invalid
                    dest = 'coordonnees';
                    if (($scope.donationForm.amountForm.$error.required && $scope.donationForm.amountForm.$error.required[0].$name === 'montant') ||
                            ($scope.donationForm.amountForm.$error.pattern && $scope.donationForm.amountForm.$error.pattern[0].$name === 'montant')) {
                        dest = 'montant';
                    }
                    $scope.formModel.pending = false;
                    $location.hash(dest);
                    $anchorScroll();
                } else {
                    drupal.createDonation({
                        email: $scope.formModel.email,
                        last_name: $scope.formModel.nom,
                        first_name: $scope.formModel.prenom,
                        salutation: $scope.formModel.civilite,
                        address: typeof $scope.formModel.adresse === 'string' ? $scope.formModel.adresse : $scope.formModel.route,
                        address2: $scope.formModel.complement || '',
                        zipcode: $scope.formModel.codepostal,
                        city: $scope.formModel.ville,
                        country: $scope.formModel.pays,
                        phone: $scope.formModel.telephone || '',
                        opt_in_foundation: !!$scope.formModel.supplements_glenansavenir,
                        opt_in_association: !!$scope.formModel.supplements_glenans,
                        amount: $scope.formModel.montant,
                        payment_mean: $scope.formModel.paymentOptions[$scope.formModel.option].id,
                        frequency: $scope.formModel.frequence,
                        destinations: $scope.formModel.destinations.filter(function (i) { return i.checked;}).map(function (i) { return i.id;})
                    }).then(function (donation) {
                        if (donation.data.payment_mean === 'card') {
                            return drupal.getPayboxUrl(donation.data).then(function (data) {
                                // get current breakpoint
                                // see theme.css for implementation rules
                                var breakpoint = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
                                if (breakpoint === 'desktop' && data.desktop) {
                                    console.debug('url', data.desktop);
                                    document.location.href = data.desktop;
                                } else if (breakpoint === 'mobile' && data.mobile) {
                                    console.debug('url', data.mobile);
                                    document.location.href = data.mobile;
                                } else {
                                    throw 'Donation form : missing config';
                                }
                            });
                        } else {
                            $state.go('donationconfirmation', { type: donation.data.payment_mean, state: 'paid' });
                        }
                    }).catch(function (error) {
                        $state.go('donationconfirmation', { type: $scope.formModel.paymentOptions[$scope.formModel.option].id, state: 'canceled' });
                    });
                }
            };
        }],
        template:
                '<form name="donationForm" class="aqua-donationform" ng-submit="sendPaymentForm(donationForm.$valid)" novalidate>' +

                '  <donationformamount></donationformamount>' +

                '  <donationformcoordinate></donationformcoordinate>' +

                '  <donationformpayment></donationformpayment>' +

                '</form>'
    };
});
